import { cn } from '../lib/cn.js';

export interface BrandMarkProps {
  className?: string;
  showWordmark?: boolean;
}

// Inline SVG mirror of /public/favicon.svg: navy rounded square + cyan
// padlock with a magnifier ring on its body. Uses currentColor for the
// magnifier so it inverts against background tones.
export function BrandMark({ className, showWordmark = false }: BrandMarkProps) {
  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <svg
        viewBox="0 0 64 64"
        aria-hidden
        className="h-9 w-9 shrink-0 drop-shadow-[0_4px_12px_var(--accent-glow)]"
      >
        <rect width="64" height="64" rx="14" fill="#011230" />
        <path
          d="M20 26v-4a12 12 0 1 1 24 0v4h2a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V30a4 4 0 0 1 4-4h2zm6 0h12v-4a6 6 0 1 0-12 0v4z"
          fill="#64FFDA"
        />
        <circle cx="32" cy="40.2" r="7.3" fill="none" stroke="#011230" strokeWidth="3" />
        <line
          x1="37.4"
          y1="45.1"
          x2="42.5"
          y2="50.2"
          stroke="#011230"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {showWordmark ? (
        <span className="flex flex-col leading-none">
          <span className="font-display text-sm font-bold uppercase tracking-[0.22em] text-on-surface">
            Photo
          </span>
          <span className="font-display text-sm font-bold uppercase tracking-[0.22em] text-cyan">
            Vault
          </span>
        </span>
      ) : null}
    </span>
  );
}
